import { Pipe, PipeTransform } from '@angular/core';

import { toCapitalize } from '../util/string-transformation.utils';

// Note: Moving forward please use this StringTransformationPipe instead of the CapitalizePipe
@Pipe({
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value :string, everyWord :boolean = false) :string {
    return toCapitalize(value, everyWord);
  }
}
